class FooterMobileToggle extends HTMLElement {
  constructor() {
    super();
   
    this.toggleElements = document.querySelectorAll('.footer-mobile-toggle');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    window.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize();
  }

  handleResize() {
    const isDesktop = window.innerWidth >= 768;
    
    this.toggleElements.forEach(element => {
      if (isDesktop) {
        element.setAttribute('open', '');
      } else {
        element.removeAttribute('open');
      }
    });
  }
}

customElements.define('footer-mobile-toggle', FooterMobileToggle);
